import {
  setChargersStaticData,
  setCyclewaysStaticData,
  setGreenCorridor1StaticData,
  setGreenCorridor2StaticData,
  setGreenCorridor3StaticData,
  setSubwayStationsStaticData,
  setSubwayLinesStaticData,
  setTBStaticData,
  setTMStaticData,
  setBStaticData,
  setBStaticFilteredData,
  setTBStaticFilteredData,
  setTMStaticFilteredData,
  setReconstructionsPermanentStaticData,
  setReconstructionsTemporaryStaticData,
} from "../redux/actions/static-data-actions";
import { setReadyStaticData } from "../redux/actions/shared-actions";
import {
  fetchChargers,
  fetchCycleways,
  fetchSubwayStations,
  fetchSubwayLines,
  fetchLinesData,
  fetchReconstructionsData,
} from "./api";
import store from "../redux/store";
import { batch } from "react-redux";
import greenCorridorsStaticData from "../livemap-ui-green-corridors-regions";

/**
 * Contains api functions.
 * @namespace static_data
 * @category Services
 */
// eslint-disable-next-line
const static_data = {};
//used for the namespace in the documentation

/**
 * Fetches data for the static state and dispatches it.
 * After everything is dispatched sets the readyStaticData state to true
 * @memberof static_data
 * @function fetchStaticData
 */
export const fetchStaticData = async () => {
  fetchChargers().then((chargers) => {
    if (chargers) {
      store.dispatch(setChargersStaticData(chargers));
    }
  });
  fetchCycleways().then((cycleways) => {
    if (cycleways) {
      store.dispatch(setCyclewaysStaticData(cycleways));
    }
  });
  fetchSubwayStations().then((subwayStations) => {
    if (subwayStations) {
      store.dispatch(setSubwayStationsStaticData(subwayStations.filter((x) => x.name)));
    }
  });
  fetchSubwayLines().then((subwayLines) => {
    if (subwayLines) {
      store.dispatch(setSubwayLinesStaticData(subwayLines));
    }
  });
  fetchLinesData().then((linesData) => {
    if (linesData) {
      const TMData = [];
      const TBData = [];
      const BData = [];
      linesData.forEach((x) => {
        if (x.line.includes("A")) {
          BData.push(x);
        }
        if (x.line.includes("TM") && !x.line.includes("A")) {
          TMData.push(x);
        }
        if (x.line.includes("TB")) {
          TBData.push(x);
        }
      });

      batch(() => {
        store.dispatch(setTMStaticData(TMData));
        store.dispatch(setTBStaticData(TBData));
        store.dispatch(setBStaticData(BData));
        store.dispatch(setTMStaticFilteredData(TMData));
        store.dispatch(setTBStaticFilteredData(TBData));
        store.dispatch(setBStaticFilteredData(BData));
      });
    }
  });

  //kanachkova
  fetchReconstructionsData().then((reconstructionsData) => {
    if (reconstructionsData) {
      reconstructionsData.sites.map((x) => {
        x.polygons = [];
        x.layers.forEach((l) => {
          if (l.type !== "Point") {
            let polygon = {
              coordinates: [],
            };
            l.coordinates[0].forEach(([lng, lat]) => {
              polygon.coordinates.push({ lat: lat, lng: lng });
            });
            x.polygons.push(polygon);
          }
        });
        delete x.layers;

        if (x.endAt) {
          let [year, month, day] = x.endAt.split("-");
          let [yearFrom, monthFrom, dayFrom] = x.startAt.split("-");

          day = day.slice(0, 2);
          dayFrom = dayFrom.slice(0, 2);

          x.timestamp = Date.parse(x.endAt);

          x.endAt = `${day}-${month}-${year}`;
          x.startAt = `${dayFrom}-${monthFrom}-${yearFrom}`;
        }

        return x;
      });

      reconstructionsData.sites = reconstructionsData.sites.filter(
        (x) => x.timestamp > new Date(new Date()).getTime() || !x.timestamp
      );

      const point = reconstructionsData.sites.filter((x) => x.polygons.length === 0);
      const zone = reconstructionsData.sites.filter((x) => x.polygons.length !== 0);

      batch(() => {
        store.dispatch(setReconstructionsPermanentStaticData(point));
        store.dispatch(setReconstructionsTemporaryStaticData(zone));
      });
    }
  });

  store.dispatch(setGreenCorridor1StaticData([greenCorridorsStaticData[0]]));
  store.dispatch(setGreenCorridor2StaticData([greenCorridorsStaticData[1]]));
  store.dispatch(setGreenCorridor3StaticData([greenCorridorsStaticData[2]]));

  store.dispatch(setReadyStaticData(true));
};
